<template>
  <div>
    <header class="header">
      <div class="inner">
        <div class="header-nav">
          <div class="logo-pc" @click="goMain"></div>
          <img
            src="@/assets/img/newGlobal/main/header/mt-menu.png"
            alt="menu"
            class="open-menu"
          />
          <ul class="pc-nav">
            <li class="pointer" @click="goPage('/Global')">글로벌 역량</li>
            <li class="pointer" @click="goPage('/Nurture')">
              주재원/현채인 육성
            </li>
            <li class="pointer" @click="goPage('/CrossCulture')">
              이문화 역량
            </li>
            <li class="pointer" @click="goPage('/Leadership')">
              리더십 및 조직개발
            </li>
            <li class="pointer" @click="goPage('/Digital')">디지털 역량</li>
            <li class="pointer" @click="goPage('/Customized')">
              맞춤 해외 연수
            </li>
            <li class="pointer" @click="goPage('/Consulting')">
              진단 및 컨설팅
            </li>
            <li class="pointer" @click="goPage('/Introduce')">회사소개</li>
            <li class="pointer" @click="openPage('http://carrotglobal.net/')">
              English
            </li>
            <li>
              <div class="family-wrapper">
                <select @change="changeSelectBox" v-model="site">
                  <option value="">패밀리 사이트</option>
                  <option value="https://www.carrotenglish.com/">
                    당근영어:모바일 화상
                  </option>
                  <option value="https://gosiliconvalley.co.kr/">
                    실리콘밸리 리더십코스
                  </option>
                  <option value="https://www.expatcare.co.kr/">
                    리:로케이션 서비스
                  </option>
                  <option value="https://biz.carrotenglish.com/edu-tech">
                    온라인ºAI과정
                  </option>
                  <option value="https://www.how-writing.com/how_intro">
                    HOW Writing
                  </option>
                  <option value="http://www.thespac.net/new/">
                    SPAC^ 말하기평가센터
                  </option>
                  <option value="http://www.thegcat.com/">
                    gCAT 글로벌역량진단
                  </option>
                </select>
              </div>
            </li>
          </ul>
        </div>
        <div class="mt-nav">
          <div class="content-wrapper">
            <div class="icon-wrapper">
              <div @click="goMain">
                <img
                  src="@/assets/img/newGlobal/main/header/logo-mt.png"
                  alt="logo"
                  class="logo"
                />
              </div>
              <img
                src="@/assets/img/newGlobal/main/header/mt-close.png"
                alt="close"
                class="close-menu"
              />
            </div>
            <ul>
              <li class="pointer" @click="goPage('/Global')">글로벌 역량</li>
              <li class="pointer" @click="goPage('/Nurture')">
                주재원/현채인 육성
              </li>
              <li class="pointer" @click="goPage('/CrossCulture')">
                이문화 역량
              </li>
              <li class="pointer" @click="goPage('/Leadership')">
                리더십 및 조직개발
              </li>
              <li class="pointer" @click="goPage('/Digital')">디지털 역량</li>
              <li class="pointer" @click="goPage('/Customized')">
                맞춤 해외 연수
              </li>
              <li class="pointer" @click="goPage('/Consulting')">
                진단 및 컨설팅
              </li>
              <li class="pointer" @click="goPage('/Introduce')">회사소개</li>
              <li class="pointer" @click="openPage('http://carrotglobal.net/')">
                English
              </li>
              <li>
                <div class="family-wrapper mt">
                  <select
                    name=""
                    id=""
                    @change="changeSelectBox"
                    v-model="site"
                  >
                    <option value="">패밀리 사이트</option>
                    <option value="https://www.carrotenglish.com/">
                      당근영어:모바일 화상
                    </option>
                    <option value="https://gosiliconvalley.co.kr/">
                      실리콘밸리 리더십코스
                    </option>
                    <option value="https://www.expatcare.co.kr/">
                      리:로케이션 서비스
                    </option>
                    <option value="https://biz.carrotenglish.com/edu-tech">
                      온라인ºAI과정
                    </option>
                    <option value="https://www.how-writing.com/how_intro">
                      HOW Writing
                    </option>
                    <option value="http://www.thespac.net/new/">
                      SPAC^ 말하기평가센터
                    </option>
                    <option value="http://www.thegcat.com/">
                      gCAT 글로벌역량진단
                    </option>
                  </select>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  data() {
    return {
      site: "",
    };
  },
  mounted() {
    // header logo img change
    const curPage = window.location.pathname;
    let logoPc = document.querySelector(".logo-pc");

    if (curPage === "/") {
      logoPc.style.backgroundImage =
        "url('https://kr.object.ncloudstorage.com/newglobal/header/logo-pc1.png')";
    } else {
      logoPc.style.backgroundImage =
        "url('https://kr.object.ncloudstorage.com/newglobal/header/logo-pc2.png')";
    }

    // header mobile nav
    const mtMenu = document.querySelector(".mt-nav");

    const openMenu = document.querySelector(".open-menu");
    openMenu.addEventListener("click", function () {
      mtMenu.style.display = "block";
    });

    const closeMenu = document.querySelector(".close-menu");
    closeMenu.addEventListener("click", function () {
      mtMenu.style.display = "none";
    });

    window.addEventListener("DOMContentLoaded", function () {
      if (screen.width > 1200) {
        mtMenu.style.display = "none";
      }
    });

    window.addEventListener("resize", function () {
      if (screen.width > 1200) {
        mtMenu.style.display = "none";
      }
    });
  },
  methods: {
    changeSelectBox() {
      if (this.site) {
        window.open(this.site, "_blank");
      }
    },
    goMain() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
    openPage(path) {
      window.open(path, "_blank");
    },
    goPage(path) {
      location.href = path;
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  transition: 0.2s;

  &.active {
    background-color: #ffffff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

    .inner {
      .header-nav {
        .logo-pc {
          background-image: url("https://kr.object.ncloudstorage.com/newglobal/header/logo-pc1.png") !important;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }

        .pc-nav > li {
          color: #000000;
          text-shadow: none;
        }
      }
    }
  }

  .inner {
    position: relative;
    padding: 20px;

    a,
    li {
      font-size: 15px;
      color: #ffffff;
    }

    .header-nav {
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        cursor: pointer;
      }

      .logo-pc {
        width: 200px;
        height: 26px;
        background-image: url("https://kr.object.ncloudstorage.com/newglobal/header/logo-pc1.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        cursor: pointer;
      }

      .open-menu {
        width: 18px;
      }

      .pc-nav {
        display: none;
      }
    }

    .mt-nav {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.8);

      .content-wrapper {
        padding: 20px;
        background-color: #2a2929;

        .icon-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .logo {
            width: 200px;
          }

          .close-menu {
            width: 21px;
            height: 21px;
            cursor: pointer;
          }
        }

        ul li {
          padding: 10px 0;
          border-bottom: 1px solid #5b5757;
        }

        .family-wrapper.mt {
          display: block;

          select {
            font-family: "Noto Sans KR";
            display: block;
            font-size: 15px;
            color: #ffffff;
            -webkit-appearance: button;
            -moz-appearance: button;
            appearance: button;
            outline: button;

            option {
              color: #000000;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  header {
    .inner {
      padding: 22px 20px;

      .header-nav {
        max-width: 1300px;
        margin: 0 auto;

        .open-menu {
          display: none;
        }

        .pc-nav {
          display: flex;
          align-items: center;
          gap: 0 20px;

          a,
          li {
            font-size: 14px;
            text-shadow: 0px 0px 14px rgb(26 25 18);
          }

          .family-wrapper {
            display: block;

            select {
              font-family: "Noto Sans KR";
              display: block;
              background-color: #ffffff;
              -webkit-appearance: button;
              -moz-appearance: button;
              appearance: button;
              outline: button;
              box-shadow: 0px 0px 14px rgb(0, 0, 0, 0.2);
              padding: 5px 7px;
              border-radius: 6px;
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }

      .mt-nav {
        display: none;
      }
    }
  }
}
</style>
